import styled, { css } from 'styled-components';

export const StyledButton = styled.button`
  position: relative;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: ${({ $gap }) => ($gap ? $gap : '5px')};
  padding: 12px 14px;
  border-radius: ${({ $rounded }) => ($rounded ? '60px' : '10px')};
  font-size: 14px;
  line-height: 18px;
  font-weight: 400;
  width: 100%;
  max-width: ${({ $width }) => $width && $width};
  background: linear-gradient(90deg, #247df3 0%, #04c8fe 100%);
  color: var(--white);
  transition: 0.5s all ease-in-out;
  overflow: hidden;
  /* z-index: -1; */

  ${({ $loader }) =>
    $loader &&
    css`
      cursor: not-allowed;
    `}

  ${({ disabled }) =>
    disabled &&
    css`
      cursor: not-allowed;
      background: var(--gray-100) !important;
      color: var(--light-gray) !important;
    `}

  ${({ $lg }) =>
    $lg &&
    css`
      padding: 16px 20px;
      font-size: 22px;
      line-height: 26px;
      font-weight: 700;
      width: ${({ $width }) => ($width ? $width : '283px')};
    `}
  ${({ $md }) =>
    $md &&
    css`
      font-size: 14px;
      line-height: 18px;
      padding: 8px 12px;
      width: ${({ $width }) => ($width ? $width : '283px')};
    `}

    ${({ $newStyle }) =>
    $newStyle &&
    css`
      padding: 11px 20px;
      font-weight: 600;
      max-width: ${({ $width }) => $width && $width};
    `}

  
  /***** Background-Variants-Start *****/
  ${({ $variant }) =>
    $variant === 'white' &&
    css`
      background: var(--white);
      color: var(--primary);
      box-shadow: 0px 3px 10px 0px #0000001a;
      padding: 12px 14px;
      .loader {
        border-top: 3px solid var(--link-color) !important;
      }
    `}
  
  ${({ $variant }) =>
    $variant === 'primary' &&
    css`
      background: var(--primary);
      color: var(--white);
      padding: 12px 15px;
    `}
    ${({ $variant }) =>
    $variant === 'light' &&
    css`
      background: rgba(53, 91, 133, 0.05);
      color: var(--text-color);
      padding: 14px 27px;
    `}
    ${({ $variant }) =>
    $variant === 'darkBlue' &&
    css`
      background: var(--blue);
      color: var(--white);
    `}
    ${({ $variant }) =>
    $variant === 'outline' &&
    css`
      color: #212325;
      border: 1px solid #e6e7ec;
      background: #fff;
    `}
    ${({ $variant }) =>
    $variant === 'secondary' &&
    css`
      color: var(--blue);
      background: rgba(49, 123, 255, 0.1);
    `}
  ${({ $variant }) =>
    $variant === 'danger' &&
    css`
      background: rgba(194, 6, 6, 0.1);
      color: var(--danger);
    `}
    ${({ $variant }) =>
    $variant === 'dark' &&
    css`
      background: var(--primary);
      color: var(--white);
    `}
    ${({ $variant }) =>
    $variant === 'underline' &&
    css`
      color: #212325;
      text-decoration: underline;
      background: none;

      &:hover {
        text-decoration: none;
      }
    `}
    ${({ $variant }) =>
    $variant === 'gradient' &&
    css`
        background: linear-gradient(
        90deg,
        #367eee 0%,
        #b74bff 50.96%,
        #feb508 100%
      );
      color: var(--white);
    `}
    ${({ $variant }) =>
    $variant === 'onboarding-gradient' &&
    css`
    border-radius: 12px;
         background-image: var(--onboarding-brand-gradient);
      color: var(--white);

    `}
  /*****************Background Variants End*********************/


  /*****************Border Variants Start*********************/

  ${({ $outline }) =>
    $outline &&
    css`
      color: var(--blue);
      border: 1px solid var(--blue);
      background: transparent;

      &:hover {
        color: var(--white);
        background: linear-gradient(180deg, #1edce3 0%, #2783ec 100%);
      }
    `}
  /*****************Border Variants End*********************/

    .loader {
    width: 17px;
    height: 17px;
    border-radius: 50%;
    display: inline-block;
    border-top: 3px solid var(--blue);
    border-right: 3px solid transparent;
    box-sizing: border-box;
    animation: rotation 1s linear infinite;
    ${({ $lg }) =>
    $lg &&
    css`
        width: 27px;
        height: 27px;
      `}
  }

  @keyframes rotation {
    0% {
      transform: rotate(0deg);
    }
    100% {
      transform: rotate(360deg);
    }
  }

  &::before {
    position: absolute;
    content: '';
    width: 70px;
    height: 300px;
    background: rgba(255, 255, 255, 0.7);
    transform: rotate(-35deg);
    top: -100px;
    left: -100%;
    transition: all 1500ms cubic-bezier(0.19, 1, 0.22, 1);
    opacity: 0;
  }
  &:hover {
    box-shadow:
      0px 4px 3px 0px #ffffff45 inset,
      0px -3px 5px 0px #ffffff40 inset;

    box-shadow: 0px 1px 14px 0px #1fabd300;
    &:before {
      left: 150%;
      opacity: 0.4;
    }
  }
`;
